document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('[id^="ProductInfo-"]');

  productForms.forEach((formContainer) => {
    const productFormId = formContainer.querySelector('form[id^="product-form-"]');
    if (!productFormId) return;

    const variantSelects = formContainer.querySelectorAll('select, input[type="radio"]');

    const variantsData = JSON.parse(formContainer.dataset.variants);

    function updateAvailability() {
      let selectedVariant;

      // Trova la variante corrispondente alla selezione attuale
      const selectedOptions = Array.from(variantSelects).map((el) => el.value);
      selectedVariant = variantsData.find((variant) => {
        return variant.options.every((opt, index) => opt === selectedOptions[index]);
      });

      // Aggiorna pulsante aggiungi al carrello
      const addToCartBtn = formContainer.querySelector('[name="add"]') || formContainer.querySelector('button[type="submit"]');
      if (addToCartBtn) {
        if (selectedVariant && selectedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Aggiungi al carrello';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Esaurito';
        }
      }

      // Disabilita opzioni non disponibili
      variantSelects.forEach((select, selectIndex) => {
        Array.from(select.options).forEach((option) => {
          const testSelection = selectedOptions.slice();
          testSelection[selectIndex] = option.value;
          const matchingVariant = variantsData.find((variant) =>
            variant.options.every((opt, i) => opt === testSelection[i])
          );
          option.disabled = !matchingVariant?.available;
        });
      });
    }

    variantSelects.forEach((el) => el.addEventListener('change', updateAvailability));
    updateAvailability(); // inizializza
  });
});
